<template>
  <v-navigation-drawer
    app
    clipped
    width="300"
    color="secondary"
    v-model="drawer"
    style="z-index: 999; top: 64px;"
  >
    <v-list>
      <v-list-item to="/" class="pl-9">
        <v-list-item-action>
          <v-icon class="material-icons-outlined">home</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item to="/managed-devices" class="pl-9">
        <v-list-item-action>
          <v-icon>laptop</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Managed Devices</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

<!--      <v-list-item to="/internet-usage" class="pl-9">-->
<!--        <v-list-item-action>-->
<!--          <v-icon>language</v-icon>-->
<!--        </v-list-item-action>-->
<!--        <v-list-item-content>-->
<!--          <v-list-item-title>Internet Usage</v-list-item-title>-->
<!--        </v-list-item-content>-->
<!--      </v-list-item>-->

      <v-list-item to="/network-usage" class="pl-9">
        <v-list-item-action>
          <v-icon>network_check</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Network Usage</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item to="/roadmap" class="pl-9">
        <v-list-item-action>
          <v-icon class="material-icons-outlined">directions</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Roadmap</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item to="/help-and-support" class="pl-9">
        <v-list-item-action>
          <v-icon>help_outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Help & Support</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!--
      <v-list-item
        href="javascript:void(0);"
        id="issue-tracker"
        class="pl-9"
        @click="sendLinkClickDataToGA('Feedback','feedback')"
      >
        <v-list-item-action>
          <v-icon class="material-icons-outlined">feedback</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Feedback</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      -->

      <v-list-item
        href="https://drive.google.com/uc?export=download&id=19v0VLrzklsS4M0rrIbBl67x29mul04zl"
        target="_blank"
        class="pl-9"
        @click="sendLinkClickDataToGA('Digital Maturity Framework','Digital Maturity Framework')"
      >
        <v-list-item-action>
          <v-icon class="material-icons-outlined">class</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Digital Maturity Framework</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item class="pl-9">
        <v-list-item-action>
        </v-list-item-action>
        <v-list-item-content v-if="version">
          Version {{version}}
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  import {mapGetters, mapActions} from "vuex";

  export default {
    name: "NavigationDrawer",
    props: {},
    data() {
      return {
        drawer: null
      };
    },
    created() {
      this.fetchOpenshiftInfo();
      this.$eventHub.$on('toggleNavigationDrawer', this.toggleNavigationDrawer);
    },
    methods: {
      ...mapActions(['fetchOpenshiftInfo']),
      toggleNavigationDrawer() {
        this.drawer = !this.drawer;
        this.drawer ? this.$parent.$el.classList.add("navOpen") : this.$parent.$el.classList.remove("navOpen");
      },
      sendLinkClickDataToGA(pageName,label) {
        console.log(pageName+':'+ label);
        this.$ga.event({
          eventCategory: `${pageName}`,
          eventAction: 'link-click',
          eventLabel: `link: ${label}`
        });
      }
    },
    computed: {
      ...mapGetters(['version'])
    },
  };
</script>

<style scoped>
  .v-list-item--active {
    border-left: 4px solid #041E42;
    /*color: #041E42;*/
    /*opacity: 0.5;*/
    /*box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);*/
    background-color: #E1EBF6;
  }

  .v-navigation-drawer.theme--light .v-list .v-list-item {
    color: #041E42 !important;
    min-height: 64px;
  }

  .theme--light.v-icon {
    color: #041E42 !important;
  }

  .v-navigation-drawer.theme--light .v-list {
    padding: 0;
  }

  .v-navigation-drawer.theme--light .v-list .v-list-item:hover {
    background-color: #D3E1F2;
  }

  .theme--light.v-list-item:hover::before {
    opacity: 0;
  }
</style>
